import React from 'react'
import { Form, Select } from 'antd'

import { Estabelecimento } from 'Hooks/estabelecimento/useEstabelecimentos'

import type { FormItemProps } from 'antd/es/form'
import type { SelectProps } from 'antd/es/select'

const { Option } = Select

interface EstabelecimentoSelectProps {
  estabelecimentos: Estabelecimento[]
  antdFormItemProps?: FormItemProps
  antdSelectProps?: SelectProps<string | number>
}

interface EstabelecimentoSelectComponentProps {
  antdSelectProps?: SelectProps<string | number>
  estabelecimentos: Estabelecimento[]
}

export const EstabelecimentoSelectComponent: React.FC<EstabelecimentoSelectComponentProps> = ({
  antdSelectProps = {},
  estabelecimentos,
  ...rest
}) => {
  const estabelecimentosOrdenados = Array.from(estabelecimentos).sort((a, b) => {
    if (typeof a.apelidooufantasia === 'string' && typeof b.apelidooufantasia === 'string') {
      return a.apelidooufantasia.toLowerCase() < b.apelidooufantasia.toLowerCase() ? -1 : 1
    }

    if (typeof a.nomeourazaosocial === 'string' && typeof b.nomeourazaosocial === 'string') {
      return a.nomeourazaosocial.toLowerCase() < b.nomeourazaosocial.toLowerCase() ? -1 : 1
    }

    return 0
  })
  return (
    <Select
      showSearch
      filterOption={(input: string, option: unknown) => {
        const opt = option as { children?: unknown } | undefined
        const children = opt?.children
        const text = typeof children === 'string' || typeof children === 'number' ? String(children) : ''
        return text.toLowerCase().includes(input.toLowerCase())
      }}
      {...rest}
      {...antdSelectProps}
    >
      {estabelecimentosOrdenados.map((estabelecimento) => (
        <Option key={estabelecimento.idestabelecimento} value={estabelecimento.idestabelecimento}>
          {estabelecimento.descricao}
        </Option>
      ))}
    </Select>
  )
}

const EstabelecimentoSelect: React.FC<EstabelecimentoSelectProps> = ({
  antdFormItemProps = {},
  antdSelectProps = {},
  estabelecimentos,
}) => (
  <Form.Item label="Estabelecimento" name="idestabelecimento" {...antdFormItemProps}>
    <EstabelecimentoSelectComponent
      showSearch
      filterOption={(input: string, option: unknown) => {
        const opt = option as { children?: unknown } | undefined
        const children = opt?.children
        const text = typeof children === 'string' || typeof children === 'number' ? String(children) : ''
        return text.toLowerCase().includes(input.toLowerCase())
      }}
      {...antdSelectProps}
      estabelecimentos={estabelecimentos}
    />
  </Form.Item>
)

export default EstabelecimentoSelect
